// extracted by mini-css-extract-plugin
export default {"title":"plp-product-banner-size__title___1eD0g","size":"plp-product-banner-size__size___1nxKI"};